var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#ECF1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9609 28.6758H30.6233V38.6501H28.9609V28.6758Z",
    fill: "#FF7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9531 28.6758H35.6155V38.6501H33.9531V28.6758Z",
    fill: "#FF7A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 23.6875V25.3499H23.9749V41.9738C23.9749 42.4147 24.15 42.8376 24.4618 43.1493C24.7736 43.4611 25.1964 43.6362 25.6373 43.6362H38.9364C39.3773 43.6362 39.8002 43.4611 40.1119 43.1493C40.4237 42.8376 40.5988 42.4147 40.5988 41.9738V25.3499H42.2612V23.6875H22.3125ZM25.6373 41.9738V25.3499H38.9364V41.9738H25.6373Z",
    fill: "#FF7A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9609 20.3633H35.6105V22.0257H28.9609V20.3633Z",
    fill: "#FF7A7A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutlinedIcon);
export default __webpack_public_path__ + "static/media/DeleteOutlinedIcon.5fbc1b8ec25e68ac269a75e23c3feb26.svg";
export { ForwardRef as ReactComponent };